import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "../memberAsMember";

export const useMutationMembershipCancelByMembershipIdAsMember = ({
  api,
}: {
  api: ApiType;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      opts: Parameters<
        ApiType["customerMembershipApi"]["membershipCancelByMembershipId"]
      >[0],
    ) => api.customerMembershipApi.membershipCancelByMembershipId(opts),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.getCurrentMembershipSubscription(),
      }),
  });
};
